import { FieldErrors, Resolver } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { FieldError } from 'react-hook-form/dist/types/errors'
import {
  HouseConsignmentFormValues,
} from 'features/declaration/house-consignment/models/schema'
import ConsignmentItemSchema, { ConsignmentItemFormValues } from 'features/declaration/consignment-item/models/schema'
import setFieldErrorByPath from 'shared/rhf/setFieldErrorByPath'
import validateConsignmentItemFormFieldStates from '../../form/validations/fieldStates/consignmentItem'
import ConsignmentItemFormResolverContext from './ConsignmentItemFormResolverContext'

const consignmentItemFormResolver: Resolver<ConsignmentItemFormValues, ConsignmentItemFormResolverContext> = async (
  values,
  context,
  options,
) => {
  const baseZodResolver = zodResolver(ConsignmentItemSchema)
  const zodResult = await baseZodResolver(values, context, options)

  const fieldErrors = validateConsignmentItemFormFieldStates(values, {
    ...(context?.validationContextRef?.current ?? {
      specificCircumstanceIndicator: '',
      security: '0',
      isEns: false,
      additionalDeclarationType: 'A',
      country: null,
      isDraft: true,
    }),
    serverValidationResult: context?.serverValidationResult,
  })

  const errors: FieldErrors<HouseConsignmentFormValues> = { ...zodResult.errors }

  for (const err of fieldErrors) {
    const codeSuffix = err.code ? `:${err.code}` : ''
    setFieldErrorByPath(errors, err.path, {
      type: `ncts${codeSuffix}`,
      message: err.message,
    } as FieldError)
  }

  const hasErrors = Object.keys(errors).length > 0

  return {
    values: hasErrors ? {} : zodResult.values,
    errors,
  }
}

export default consignmentItemFormResolver
